module.exports = __webpack_public_path__ + "static/media/cleanspaces.fdbb0967.png";